import MainFooterLayout from './MainFooterLayout.vue';

export default MainFooterLayout;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulemain/components/mainfooterlayout/index.ts